import sealImg from "@/assets/logo-seal-primary.png";
import { cn } from "@/lib/utils";

interface BrandSealProps {
  size?: number;
  className?: string;
  /** Optional bronze halo glow behind the seal — use on dark navy surfaces */
  glow?: boolean;
}

/**
 * The refined "Currency Thoughts" emblem — a polished evolution of the
 * original circular seal. Use on hero, footer, auth, and any surface that
 * needs the full brand mark (not the wordmark-only Logo).
 */
export function BrandSeal({ size = 220, className, glow = false }: BrandSealProps) {
  return (
    <span
      className={cn("relative inline-block", className)}
      style={{ width: size, height: size }}
    >
      {glow && (
        <span
          aria-hidden
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(201,168,118,0.25) 0%, rgba(201,168,118,0) 65%)",
            filter: "blur(8px)",
            transform: "scale(1.15)",
          }}
        />
      )}
      <img
        src={sealImg}
        alt="Currency Thoughts seal — Building Generational Wealth, Est. 2021"
        width={size}
        height={size}
        className="relative block h-full w-full select-none"
        draggable={false}
      />
    </span>
  );
}

export default BrandSeal;